'use client';

import { useDecisions } from '@libs/common-next';

type FraudValidationHookResult = {
    isFraudValidationNeeded: boolean;
};

export function useFraudValidation(): FraudValidationHookResult {
    const isFraudValidationEnabled = useDecisions('ff_fraud_validation');

    return {
        isFraudValidationNeeded: isFraudValidationEnabled,
    };
}
